import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const GasStationsPage = lazy(() => import('../pages/gas-stations/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const MachineryPage = lazy(() => import('../pages/machinery/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hizmetler',
    element: <ServicesPage />,
  },
  {
    path: '/projeler',
    element: <ProjectsPage />,
  },
  {
    path: '/benzinlikler',
    element: <GasStationsPage />,
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/makina-parkuru',
    element: <MachineryPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
